export const funcId = {
  // なし
  none: 0,
  // 研修実施結果記録
  trainingRecord: 1,
  // テスト実施結果記録
  examRecord: 2,
  // 研修検索
  training: 101,
  // 研修検索編集
  trainingEdit: 104,
  // 実施研修検索
  replicationTraining: 201,
  // 実施編集
  replicationEdit: 204,
  // テスト検索
  exam: 301,
  // テスト編集
  examEdit: 305,
  // 実施テスト検索
  replicationExam: 401,
  // 実施テスト実施状況閲覧
  replicationExamCondition: 402,
  // 実施テスト一括採点
  replicationExamScoring: 408,
  // 未実施遺留
  // 研修登録
  trainingRegister: 501,
  // テスト登録
  examRegister: 601,
  // 実施設定登録
  replicationRegister: 701,
  // 未実施登録
  unadministeredRegister: 704,
  // カテゴリマスタ閲覧
  category: 801,
  // カテゴリマスタ新規登録
  categoryRegister: 802,
  // カテゴリマスタ編集
  categoryEdit: 803,
  // グループマスタ閲覧
  group: 901,
  // グループマスタ新規登録
  groupRegister: 902,
  // グループマスタ編集
  groupEdit: 903,
  // ユーザーマスタ閲覧
  user: 1001,
  // ユーザーマスタ編集
  userEdit: 1002
}



// WEBPACK FOOTER //
// ./src/store/utils/func_id_list.js